import { render, staticRenderFns } from "./search-left.vue?vue&type=template&id=2322fa4a&scoped=true"
import script from "./search-left.vue?vue&type=script&lang=js"
export * from "./search-left.vue?vue&type=script&lang=js"
import style0 from "./search-left.vue?vue&type=style&index=0&id=2322fa4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2322fa4a",
  null
  
)

export default component.exports